import { RemoveBasketItemType } from '../types/basket';
import * as BasketControl from '../weborder/BasketControl';
import * as Store from '../weborder/Store';
import { Utilities } from '../weborder/Utilities';

type RemoveItemPayloadType = {
  index: number;
  indexName?: string;
  menuId: number;
};

const getViewportTopOffset = (isMobile = false): number => {
  const getViewportTopOffsetFromStore = () => {
    const store = Store.getStoreInstance();

    if (!store) {
      return 0;
    }

    const state = store.getState();

    const { flipdish } = state;
    const appConfig = flipdish?.AppConfig;

    if (appConfig && appConfig.status === 'success') {
      return appConfig.data.ViewportTopOffset;
    }

    return 0;
  };

  const viewportTopOffset = getViewportTopOffsetFromStore();

  if (!isMobile) {
    return viewportTopOffset;
  }

  const fullScreenOnMobile =
    (Utilities.extraOption &&
      Utilities.extraOption('data-full-screen-on-mobile')) ||
    false;
  const isfullScreenOnMobile = fullScreenOnMobile !== 'false';
  return (!isfullScreenOnMobile && viewportTopOffset) || 0;
};

const handleAddItem = (
  actionAddItem: (payload: BasketControl.Item) => void,
  data: BasketControl.Item,
): void => {
  actionAddItem({
    Item: data.Item,
    Options: data.Options,
  });
};

const handleScrollToSection = (
  targetId: string,
  isMobile: boolean,
  partialOffset = 0,
): void => {
  const viewportTopOffset: number = menuUtils.getViewportTopOffset(isMobile);
  const targetSection = document.getElementById(targetId);

  const yOffset =
    targetSection.getBoundingClientRect().top +
    window.pageYOffset -
    partialOffset -
    viewportTopOffset;

  window.scrollTo({
    behavior: 'smooth',
    top: yOffset,
  });
};

const handleRemoveItem = (
  actionRemoveItem: (payload: RemoveItemPayloadType) => void,
  data: RemoveBasketItemType,
): void => {
  actionRemoveItem({
    index: data.index,
    indexName: data.item.Name,
    menuId: data.menuId,
  });
};

export const menuUtils = {
  getViewportTopOffset,
  handleAddItem,
  handleRemoveItem,
  handleScrollToSection,
};
